import getAuthHeaders from "./authHeaders";
export default async function fetchStopMessage(chatId:string, apiAddress:string) {
    const link = `${apiAddress}/cancel_run`;
    const body = {
        chatId,
    }
  
    const response = await fetch(link, {
      method: 'POST',
      headers: await getAuthHeaders({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(body),
    })

    return response.json()

  }
